import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, commonIdGetDesiredUniversitiesFeatureKey } from '../../reducers/common-id/common-id-get-desired-universities.reducer';

const selectCommonIdGetDesiredUniversitiesState = createFeatureSelector<State>(commonIdGetDesiredUniversitiesFeatureKey);

export const getCommonIdGetDesiredUniversitiesResult = createSelector(selectCommonIdGetDesiredUniversitiesState, state => state.result);
